(function () {
  'use strict';

  var modal = document.getElementById('sf-newsletter-modal');
  if (!modal) return;

  var cfg = {
    companyId:  modal.dataset.companyId || '',
    listId:     modal.dataset.listId || '',
    endpoint:   (modal.dataset.endpoint || '').trim(),   // "" = call Klaviyo directly
    discountCode: (modal.dataset.discountCode || '').trim(),
    cookieName: 'sf_newsletter_seen',
    cookieDays: parseInt(modal.dataset.cookieDays, 10) || 30,
    delay:      parseInt(modal.dataset.delay, 10) || 0,
    revision:   '2024-10-15',                            // Klaviyo API revision
    targetRegions: (modal.dataset.region || 'CA').toUpperCase()
                     .split(',').map(function (s) { return s.trim(); })
  };

  // Resolve the email input robustly. Do NOT rely on name="email":
  // depending on markup the name may differ, so prefer the stable id, then
  // fall back to the only email-type input in the modal.
  var form      = modal.querySelector('.sf-modal__form');
  var emailEl   = modal.querySelector('#sf-modal-email') ||
                  modal.querySelector('input[type="email"]');
  var consentEl = modal.querySelector('input[name="privacy"]');
  var submitBtn = form ? form.querySelector('.sf-modal__submit') : null;
  var errorEl   = modal.querySelector('.sf-modal__error');
  var successEl = modal.querySelector('.sf-modal__success');
  var lastFocus = null;
  var submitted = false;

  // Fail loudly in the console if the markup/config is wired up wrong, rather
  // than throwing mid-submit and leaving the visitor stuck.
  if (!form || !emailEl || !consentEl || !submitBtn) {
    console.error('[newsletter-modal] Missing required elements; aborting.', {
      form: !!form, emailEl: !!emailEl, consentEl: !!consentEl, submitBtn: !!submitBtn
    });
    return;
  }
  if (!cfg.endpoint && (!cfg.companyId || !cfg.listId)) {
    console.warn('[newsletter-modal] No relay endpoint and missing Klaviyo ' +
                 'company id / list id — direct submissions will fail. Set ' +
                 'data-company-id + data-list-id, or data-endpoint.');
  }

  /* ---------- first-party cookie helpers ---------- */
  function setCookie(name, value, days) {
    var d = new Date();
    d.setTime(d.getTime() + days * 864e5);
    document.cookie = name + '=' + encodeURIComponent(value) +
      ';expires=' + d.toUTCString() + ';path=/;SameSite=Lax';
  }
  function getCookie(name) {
    return document.cookie.split('; ').reduce(function (acc, c) {
      var p = c.split('=');
      return p[0] === name ? decodeURIComponent(p.slice(1).join('=')) : acc;
    }, null);
  }
  function suppress() { setCookie(cfg.cookieName, '1', cfg.cookieDays); }

  /* ---------- Global Privacy Control (do-not-sell/share signal) ----------
     We still show a first-party opt-in form, but we RECORD the signal so the
     downstream system has an audit trail and can honor it for sale/sharing. */
  function gpcActive() {
    return navigator.globalPrivacyControl === true;
  }

  /* ---------- open / close ---------- */
  function open() {
    if (getCookie(cfg.cookieName)) return;        // already suppressed
    lastFocus = document.activeElement;
    modal.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    (emailEl || modal).focus();
    document.addEventListener('keydown', onKeydown);
  }
  function close() {
    modal.hidden = true;
    document.documentElement.style.overflow = '';
    document.removeEventListener('keydown', onKeydown);
    if (!submitted) suppress();                    // don't overwrite the 365-day "submitted" cookie
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function onKeydown(e) {
    if (e.key === 'Escape') { close(); return; }
    if (e.key === 'Tab') trapFocus(e);
  }
  function trapFocus(e) {
    var f = modal.querySelectorAll(
      'a[href],button:not([disabled]),input:not([disabled]),[tabindex]:not([tabindex="-1"])'
    );
    f = Array.prototype.filter.call(f, function (el) { return el.offsetParent !== null; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  modal.querySelectorAll('[data-sf-close]').forEach(function (el) {
    el.addEventListener('click', close);
  });

  /* ---------- validation ---------- */
  function showError(msg) {
    errorEl.textContent = msg;
    errorEl.hidden = false;
  }
  function clearError() { errorEl.hidden = true; errorEl.textContent = ''; }

  /* ---------- submit ---------- */
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    clearError();

    var email = (emailEl.value || '').trim();
    if (!emailEl.checkValidity() || !email) {
      emailEl.setAttribute('aria-invalid', 'true');
      showError('Please enter a valid email address.');
      emailEl.focus();
      return;
    }
    emailEl.removeAttribute('aria-invalid');

    if (!consentEl.checked) {
      showError('Please agree to the Privacy Policy to continue.');
      consentEl.focus();
      return;
    }

    submitBtn.disabled = true;
    submitBtn.textContent = 'Submitting\u2026';

    var consentMeta = {
      privacy_policy_agreed: true,
      consent_timestamp: new Date().toISOString(),
      gpc_signal: gpcActive(),
      source: 'first_party_modal',
      page_url: location.href
    };

    subscribe(email, consentMeta)
      .then(async function () {
        submitted = true;
        setCookie(cfg.cookieName, '1', 365);

        const response = await fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            discount: cfg.discountCode
          })
        });

        const cart = await response.json();
        console.log(cart);

        form.hidden = true;
        successEl.hidden = false;
        successEl.querySelector('[data-sf-close]').focus();
      })
      .catch(function (err) {
        console.error('[newsletter-modal]', err);
        submitBtn.disabled = false;
        submitBtn.textContent = 'Claim Offer';
        showError('Something went wrong. Please try again.');
      });
  });


  /* ---------- delivery ----------
     Option B (relay): POST to your same-origin endpoint. Preferred, because
     no request points at klaviyo.com, so no CMP category can block it.
     Option A (direct): call Klaviyo's public client subscription endpoint. */
  function subscribe(email, meta) {
    if (cfg.endpoint) {
      return fetch(cfg.endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email, list_id: cfg.listId, consent: meta })
      }).then(assertOk);
    }
    return subscribeDirect(email, meta);
  }

  function subscribeDirect(email, meta) {
    var url = 'https://a.klaviyo.com/client/subscriptions/?company_id=' +
              encodeURIComponent(cfg.companyId);
    var payload = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'Newsletter Modal',
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email,
                properties: meta            // consent audit fields ride along
              }
            }
          }
        },
        relationships: { list: { data: { type: 'list', id: cfg.listId } } }
      }
    };
    return fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'revision': cfg.revision
      },
      body: JSON.stringify(payload)
    }).then(assertOk);
  }

  function assertOk(res) {
    if (!res.ok && res.status !== 202) {
      return res.text().then(function (t) { throw new Error(res.status + ' ' + t); });
    }
    return res;
  }

  var copyEl = modal.querySelector('[data-sf-copy]');
  if (copyEl) {
    copyEl.addEventListener('click', function () {
      var code = copyEl.getAttribute('data-code') || cfg.discountCode;
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).catch(fallbackCopy);
      } else {
        fallbackCopy();
      }
      function fallbackCopy() {
        var t = document.createElement('textarea');
        t.value = code;
        t.setAttribute('readonly', '');
        t.style.position = 'absolute';
        t.style.left = '-9999px';
        document.body.appendChild(t);
        t.select();
        try { document.execCommand('copy'); } catch (e) {}
        document.body.removeChild(t);
      }
    });
  }

  /* ---------- geo gate (Shopify Customer Privacy API) ---------- */
  function shopifyRegion() {
    // TEST OVERRIDE: add ?sf_region=USCA to any URL to simulate a region.
    // Remembered for the browser tab; use ?sf_region=clear to remove it.
    try {
      var p = new URLSearchParams(location.search).get('sf_region');
      if (p === 'clear') sessionStorage.removeItem('sf_region');
      else if (p) sessionStorage.setItem('sf_region', p.toUpperCase());
      var forced = sessionStorage.getItem('sf_region');
      if (forced) return Promise.resolve(forced);
    } catch (e) {}

    return new Promise(function (resolve) {
      function read() {
        try {
          resolve(String(window.Shopify.customerPrivacy.getRegion() || '').toUpperCase());
        } catch (e) {
          resolve('');
        }
      }
      if (window.Shopify && window.Shopify.customerPrivacy) return read();
      if (window.Shopify && window.Shopify.loadFeatures) {
        window.Shopify.loadFeatures(
          [{ name: 'consent-tracking-api', version: '0.1' }],
          function (err) { err ? resolve('') : read(); }
        );
      } else {
        resolve('');
      }
    });
  }

  function isTargetRegion() {
    return shopifyRegion().then(function (region) {
      console.info('[newsletter-modal] Shopify region:', region || '(empty)');
      return cfg.targetRegions.some(function (r) {
        return region === 'US' + r;      // "USCA", "USOR"
      });
    });
  }

  /* ---------- known-subscriber check ---------- */
  function isKnownSubscriber() {
    // 1. Logged-in customer who accepts email marketing (from Liquid)
    if (modal.dataset.subscribed === 'true') return true;

    // 2. Arrived from a Klaviyo email (tracked links carry _kx)
    if (/[?&]_kx=/.test(location.search)) return true;

    // 3. Klaviyo has already identified this browser
    var kla = getCookie('__kla_id');
    if (kla) {
      try {
        var d = JSON.parse(atob(kla));
        if (d.$exchange_id || d.$email) return true;
      } catch (e) {}
    }
    return false;
  }

  /* ---------- trigger ---------- */
  isTargetRegion().then(function (inRegion) {
    if (!inRegion) return;                       // non-CA: Klaviyo shows normally

    // CA: hide the Klaviyo popup (see the sf-hide-klaviyo CSS in the theme)
    document.documentElement.classList.add('sf-hide-klaviyo');

    // CA: show our custom modal (same rules as before)
    if (getCookie(cfg.cookieName)) return;
    if (isKnownSubscriber()) { setCookie(cfg.cookieName, '1', 365); return; }
    if (cfg.delay > 0) setTimeout(open, cfg.delay);
    else open();
  });
})();
